import _ from "lodash";
import update from "immutability-helper";
import client from "lib/apolloClient/client";

import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

import {
  createIBPYPElementRatingsMutation,
  deleteIBPYPElementRatingByIdMutation,
  deleteMultipleIBPYPElementRatingsMutation,
} from "modules/CommonMutations";
import { updateElementRemarkMutation } from "ClassRoom/modules/ClassRoomMutation";
import {
  getStudentsPypElementRatingsQuery,
  getClassProgressSummaryExportQuery,
  getStudentsPypElementRatingHistoryQuery,
} from "ClassProgressSummaryV2/modules/ClassProgressSummaryQuery";

import { getRatingTableFilters } from "ClassProgressSummaryV2/modules/Utils";

import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";

import {
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_SUBJECT,
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_LEARNER_PROFILE,
  ELEMENT_TYPE_CONCEPT,
  ELEMENT_TYPE_PYP_BENCHMARK,
  ELEMENT_TYPE_ATL,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_UBD_ATL,
  PLANNER_ELEMENT,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_DP_SUBJECT,
} from "Constants/stringConstants";
import { getGradingHistoryForLearningGoalsQuery } from "AppComponents/GradingHistory/modules/GradingHistoryQueries";

import { downloadFromUrl } from "modules/Services";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import { getAllStudentsPypElementRatingsQuery } from "./ClassProgressSummaryQuery";

export const NAME = "classProgressSummaryV2";
export const UPDATE_FILTERS = "UPDATE_FILTERS" + " " + NAME;
export const RESET_FILTERS = "RESET_FILTERS" + " " + NAME;
export const MIME_TYPE_EXCEL =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const MIME_TYPE_ZIP = "application/zip";
export const updateFilters = data => {
  return { type: UPDATE_FILTERS, data };
};

export const resetFilters = () => {
  return { type: RESET_FILTERS };
};

const REDUCER_HANDLERS = {
  [UPDATE_FILTERS]: (state, action) => {
    const params = action.data;
    _.map(params, (value, key) => {
      state = update(state, {
        filters: { [key]: { $set: value } },
      });
    });
    return state;
  },
  [RESET_FILTERS]: state => {
    state = { ...state, filters: initialState.filters };
    return state;
  },
};

export const getElementTypesForEvaluation = ({ elementType }) => {
  switch (elementType) {
    case ELEMENT_TYPE_UBD_SUBJECT:
    case ELEMENT_TYPE_UBD_LEARNING_STANDARD:
      return [ELEMENT_TYPE_UBD_LEARNING_STANDARD, ELEMENT_TYPE_UBD_SUBJECT];
    case ELEMENT_TYPE_DP_SUBJECT:
    case ELEMENT_TYPE_DP_LEARNING_STANDARD:
      return [ELEMENT_TYPE_DP_LEARNING_STANDARD, ELEMENT_TYPE_DP_SUBJECT];
    case ELEMENT_TYPE_MYP_SUBJECT:
    case ELEMENT_TYPE_MYP_LEARNING_STANDARD:
      return [ELEMENT_TYPE_MYP_LEARNING_STANDARD, ELEMENT_TYPE_MYP_SUBJECT];

    default:
      return elementType;
  }
};
export const getMimeType = ({ fileType }) => {
  if (fileType === "xlsx") {
    return MIME_TYPE_EXCEL;
  }
  return MIME_TYPE_ZIP;
};
export const plannerElementTypesToCurriculumTypeMap = {
  [CURRICULUM_TYPE_PYP]: {
    plannerElements: {
      atls: ELEMENT_TYPE_ATL,
      keyConcepts: ELEMENT_TYPE_CONCEPT,
      learnerProfile: ELEMENT_TYPE_LEARNER_PROFILE,
      subjectsStandards: ELEMENT_TYPE_PYP_BENCHMARK,
    },
  },
  [CURRICULUM_TYPE_MYP]: {
    plannerElements: {
      atls: ELEMENT_TYPE_MYP_ATL,
      subjectsStandards: getElementTypesForEvaluation({
        elementType: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
      }),
    },
  },
  [CURRICULUM_TYPE_DP]: {
    plannerElements: {
      atls: ELEMENT_TYPE_DP_ATL,
      lpas: ELEMENT_TYPE_DP_LEARNER_PROFILE,
      subjectsStandards: getElementTypesForEvaluation({
        elementType: ELEMENT_TYPE_DP_LEARNING_STANDARD,
      }),
      assessmentObjectives: ELEMENT_TYPE_DP_OBJECTIVES,
    },
  },
  [CURRICULUM_TYPE_UBD]: {
    plannerElements: {
      atls: ELEMENT_TYPE_UBD_ATL,
      subjectsStandards: getElementTypesForEvaluation({
        elementType: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
      }),
    },
  },
};

export const excludedLearningGoals = [
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_DP_SUBJECT,
  ELEMENT_TYPE_MYP_SUBJECT,
];
export const plannerElementTolocaleLabelMap = {
  atls: "common:atls_label",
  lpas: "common:lp_label",
  subjectsStandards: "common",
  assessmentObjectives: "common",
};
export const getDownloadProgressSumaryInputVariables = ({
  curriculumType,
  plannerElement,
  academicYearIds,
  dataSet,
  assessmentToolTypes,
}) => {
  const filters = plannerElementTypesToCurriculumTypeMap[curriculumType];
  switch (plannerElement) {
    case "allPlannerElements": {
      const elementTypes = _.flatten(_.values(filters.plannerElements));

      return [
        {
          summaryType: PLANNER_ELEMENT,
          filters: { elementTypes },
        },
        {
          summaryType: "ALL_ASSESSMENTS_V2",
          filters: {
            academicYearIds,
            assessmentToolTypes,
          },
        },
        {
          summaryType: "TERM_OVERVIEW",
          filters: {
            academicYearIds,
          },
        },
      ];
    }
    case "ALL_LEARNING_GOALS": {
      const elementTypes = _.flatten(_.values(filters.plannerElements));
      const filteredElementTypes = _.filter(
        elementTypes,
        elementType => !_.includes(excludedLearningGoals, elementType)
      );
      return [
        {
          summaryType: PLANNER_ELEMENT,
          filters: { elementTypes: filteredElementTypes, dataSet },
        },
      ];
    }

    case "ALL_ASSESSMENTS":
    case "TERM_OVERVIEW": {
      return [
        {
          summaryType: plannerElement,
          filters: { academicYearIds },
        },
      ];
    }
    case "ALL_ASSESSMENTS_V2": {
      return [
        {
          summaryType: plannerElement,
          filters: {
            academicYearIds,
            assessmentToolTypes,
          },
        },
      ];
    }
    default: {
      const elements = _.get(filters.plannerElements, [plannerElement]);
      return [
        {
          summaryType: PLANNER_ELEMENT,
          filters: { elementTypes: elements, dataSet },
        },
      ];
    }
  }
};

export const downloadClassProgressSummary = ({
  curriculumType,
  plannerElement,
  dataSet,
  assessmentToolTypes = [],
}) => {
  return async (dispatch, getState) => {
    const courseId = _.get(
      getState(),
      "teacher.selected_class.selected_course",
      ""
    );
    const academicYearId = getSelectedAcademicYearId(getState());
    const { title } = getCourseDetailsFromCache({
      id: courseId,
      courseGradeFilters: {
        academicYearId,
      },
    });

    const courseTitle = _.join(_.split(title, " "), "_");

    try {
      const classProgressSummaryExportVariables = getDownloadProgressSumaryInputVariables(
        {
          curriculumType,
          plannerElement,
          academicYearIds: [academicYearId],
          assessmentToolTypes,
          dataSet,
        }
      );

      const queryData = await client.query({
        query: getClassProgressSummaryExportQuery,
        variables: {
          courseId,
          input: classProgressSummaryExportVariables,
        },
        fetchPolicy: "network-only",
      });

      const classProgressSummaryExport = _.get(
        queryData,
        "data.node.classProgressSummaryExport",
        {}
      );

      if (_.isEmpty(classProgressSummaryExport)) {
        return dispatch(
          setToastMsg({
            msg:
              "toastMsgs:no_rating_done_cannot_download_progress_summary_data",
            locale_params: [
              {
                key: "label",
                value: plannerElementTolocaleLabelMap[plannerElement],
                isPlainText: false,
              },
            ],
          })
        );
      }

      const fileName = _.get(
        classProgressSummaryExport,
        "fileName",
        `ClassProgressSummaryCSV_${courseTitle}`
      );
      const url = _.get(classProgressSummaryExport, "url", "");

      const fileType = _.get(classProgressSummaryExport, "fileType", "");
      dispatch(
        downloadFromUrl({
          attachment: {
            name: fileName + fileType,
            url,
            mimeType: getMimeType({ fileType }),
          },
          shouldAskForSave: true,
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

const getRatingSubjectId = ({ elementType, filterSubject, subjectIds }) => {
  switch (elementType) {
    case ELEMENT_TYPE_UBD_SUBJECT:
    case ELEMENT_TYPE_UBD_LEARNING_STANDARD: {
      return filterSubject;
    }
    default: {
      return _.first(subjectIds);
    }
  }
};

export const createPypElementRatings = ({
  subjectIds,
  elementType,
  localElementsRatings,
  createdAt,
  filterSubject,
  isGradebook,
  academicTermId,
  learningGoalsRatingStartDate,
  learningGoalsRatingEndDate,
  allStudents,
  sourceFrom,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;
    const state = getState();
    const startDate = learningGoalsRatingStartDate;
    const endDate = learningGoalsRatingEndDate;
    const filters = getRatingTableFilters({ state, isGradebook });
    const { students, criteriaSet } = filters;
    const elementRatings = _.map(localElementsRatings, rating => ({
      ...rating,
      createdBy: userId,
      parentType: "OBSERVATION",
      isPublished: true,
      subjectId: getRatingSubjectId({
        elementType: rating?.ibPYPElementType,
        filterSubject,
        subjectIds,
      }),
      createdAt,
      academicTermId,
      source: sourceFrom,
    }));

    try {
      await client.mutate({
        mutation: createIBPYPElementRatingsMutation,
        variables: { elementRatings },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentsPypElementRatingsQuery,
            variables: {
              studentIds: students,
              filtersForRecentMost: {
                academicCriteriaSetId: criteriaSet,
                elementTypes: getElementTypesForEvaluation({ elementType }),
                subjectIds,
                academicTermId,
              },
              startDate,
              endDate,
            },
          },
          {
            query: getAllStudentsPypElementRatingsQuery,
            variables: {
              studentIds: allStudents,
              filtersForRecentMost: {
                elementTypes: getElementTypesForEvaluation({ elementType }),
                subjectIds,
                academicTermId,
              },
              startDate,
              endDate,
            },
          },
        ],
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const createIBPYPElementRatings = ({
  elementRatings,
  isComment,
  source,
}) => {
  return async (dispatch, getState) => {
    const mutation = isComment
      ? updateElementRemarkMutation
      : createIBPYPElementRatingsMutation;

    const variables = !isComment
      ? { elementRatings }
      : {
          input: _.map(elementRatings, elementRating => {
            return {
              studentId: _.get(elementRating, "studentId"),
              parentId: _.get(elementRating, "parentId"),
              parentType: _.get(elementRating, "parentType"),
              message: _.get(elementRating, "value"),
              ibPYPElementType: _.get(elementRating, "ibPYPElementType"),
              createdBy: _.get(elementRating, "createdBy"),
              source,
            };
          }),
        };

    try {
      await client.mutate({
        mutation,
        variables,
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: "Something went wrong", notString: true }));
      }
    }
  };
};

export const deleteIBPYPElementRatings = ({ elementRatings }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: deleteMultipleIBPYPElementRatingsMutation,
        variables: { input: elementRatings },
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: "Something went wrong", notString: true }));
      }
    }
  };
};

export const deleteIBPYPElementRatingById = ({
  id,
  academicTermId,
  queryVariables,
  learningGoalsRatingStartDate,
  isGradebook,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const startDate = learningGoalsRatingStartDate;
    const filters = getRatingTableFilters({ state, isGradebook });
    const { students, criteriaSet } = filters;

    try {
      await client.mutate({
        mutation: deleteIBPYPElementRatingByIdMutation,
        variables: {
          id,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentsPypElementRatingHistoryQuery,
            variables: {
              studentId: queryVariables.studentId,
              endDate: queryVariables.endDate,
              filtersForRatingHistory: {
                ibPYPElementId: queryVariables.ibPYPElementId,
                ibPYPElementType: queryVariables.ibPYPElementType,
                last: 30,
                academicCriteriaSetId: queryVariables.academicCriteriaSetId,
                subjectIds: queryVariables.subjectIds,
              },
            },
          },
          {
            query: getStudentsPypElementRatingsQuery,
            variables: {
              studentIds: students,
              filtersForRecentMost: {
                academicCriteriaSetId: criteriaSet,
                elementTypes: getElementTypesForEvaluation({
                  elementType: queryVariables.ibPYPElementType,
                }),
                subjectIds: queryVariables.subjectIds,
                academicTermId,
              },
              startDate,
              endDate: queryVariables.endDate,
            },
          },
          {
            query: getAllStudentsPypElementRatingsQuery,
            variables: {
              studentIds: students,
              filtersForRecentMost: {
                elementTypes: getElementTypesForEvaluation({
                  elementType: queryVariables?.ibPYPElementType,
                }),
                subjectIds: queryVariables?.subjectIds,
                academicTermId,
              },
              startDate,
              endDate: queryVariables.endDate,
            },
          },
        ],
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            notString: true,
          })
        );
      }
    }
  };
};

export const deleteIBPYPElementRatingByIdV2 = ({
  id,
  academicTermId,
  queryVariables,
  learningGoalsRatingStartDate,
  isGradebook,
  gradingHistoryQueryVariables,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const startDate = learningGoalsRatingStartDate;
    const filters = getRatingTableFilters({ state, isGradebook });
    const { students, criteriaSet } = filters;

    const refetchQueries = [
      {
        query: getGradingHistoryForLearningGoalsQuery,
        variables: gradingHistoryQueryVariables,
      },
      {
        query: getStudentsPypElementRatingsQuery,
        variables: {
          studentIds: students,
          filtersForRecentMost: {
            academicCriteriaSetId: criteriaSet,
            elementTypes: getElementTypesForEvaluation({
              elementType: queryVariables.ibPYPElementType,
            }),
            subjectIds: queryVariables.subjectIds,
            academicTermId,
          },
          startDate,
          endDate: queryVariables.endDate,
        },
      },
      {
        query: getAllStudentsPypElementRatingsQuery,
        variables: {
          studentIds: students,
          filtersForRecentMost: {
            elementTypes: getElementTypesForEvaluation({
              elementType: queryVariables?.ibPYPElementType,
            }),
            subjectIds: queryVariables?.subjectIds,
            academicTermId,
          },
          startDate,
          endDate: queryVariables.endDate,
        },
      },
    ];

    try {
      await client.mutate({
        mutation: deleteIBPYPElementRatingByIdMutation,
        variables: {
          id,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:something_went_wrong",
            notString: true,
          })
        );
      }
    }
  };
};

const initialState = {
  filters: {
    searchText: "",
    terms: "",
    termWiseProgressReports: [],
    students: [],
    subjects: "",
    grades: [],
    units: [],
    organizationTags: [],
    criteriaSet: "",
    academicYear: "",
    assessmentTypes: "ALL",
    evaluationTypes: "ALL",
    selectedAssessmentTools: [],
    selectedAssessmentTypes: [],
    selectedTerms: [],
    selectedAcademicYears: [],
    selectedProgressReportId: "",
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
